module.exports = __webpack_public_path__ + "img/1.7f9266b1.png";